import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

import IconButton from '../components/button.jsx';

import logo from '../img/logo-dark.svg';
import arrowReturn from '../img/icon-return.svg';
import pdfLinkedIn from '../img/flyer-linkedin.pdf';
import iconSiteOffWhite from '../img/icon-site-internet-off-white-sunset.svg';
import btnArrow from '../img/btn-arrow.svg';

const OffersPage = () => {

  useEffect(() => {
    document.body.classList.add('offers-active');

    return () => {
      document.body.classList.remove('offers-active');
    };
  }, []); 

  const handleCalendlyClick = () => {
    if (window.Calendly) {
      window.Calendly.initPopupWidget({
        url: 'https://calendly.com/expertsa-ssam/mes-projets'
      });
    }
  };

  return (
    <div className='flex items-center flex-col offers container'>
      <div className="return-logo">
        <Link to="/" className='return'>
          <img src={arrowReturn} alt='flèche blanche vers la gauche dans un rond noir'/>
          <h2 className='h3-blog text-off-white'>Retour</h2>
        </Link>
        <div className='logo'>
          <img src={logo} alt='logo Expert SA' />
        </div>
      </div>
      <div className='grid-btn'>
        <div className="container-offre-rentree">
          <h2 className="h1-blog text-chocolate-20">Découvrez nos offres du moment&nbsp;!</h2>
          <div className="container-offre-rentree-inner">
            <h3 className="h3 text-sunset">Offre Septembre&nbsp;!</h3>
            <p className="great refonte-h2-main-2 text-off-white">
              Faites votre rentrée 
              <img src={iconSiteOffWhite} aria-hidden="true" role="presentation" width="53" height="87" alt="pinceau icon" dir="ltr" loading="lazy" /> 
              <span>digitale</span> <span>avec</span> 2 mois <span><span className="text-sunset">offerts</span>&nbsp;!</span>
            </p>
            <p className="text-chocolate-20 w-60">
              Commandez votre site web en septembre et profitez de <span className="highlight text-off-white">2 mois d'abonnement gratuits</span>. L'occasion parfaite pour booster votre business dès maintenant !
            </p>
            <p className="text-off-white highlight">Offre limitée - Septembre uniquement</p>
            <button onClick={handleCalendlyClick} className="btn-esa btn-bg-chocolate">
              <p>Je profite de l'offre&nbsp;!</p>
              <div className="btn-square">
                <img src={btnArrow} alt="" aria-hidden="true" role="presentation" width="14" height="14" loading="lazy" />
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OffersPage;